<template>
    <div class="contents-body" :class="classes">
        <transition appear name="fade" mode="out-in" @before-enter="whenLoading" @after-enter="afterLoading">
            <router-view class="product"></router-view>
        </transition>
        <dialogs-wrapper transition-name="fade"></dialogs-wrapper>
        <DevInfo
            service-name="Shop"
            :route-name="$route.name"
            :environment="environment"
            :current-version="currentVersion"
            :channel="channel"
            :web-api="webApi"
            :cdn-host="cdnHost"
        />
    </div>
</template>

<script>
import { DevInfo } from '@arena/toolkit';
import config from './config/environment-config';

export default {
    name: 'App',
    components: {
        DevInfo,
    },
    computed: {
        classes() {
            return [this.channel, this.region, this.language];
        },
        region() {
            return environment.region;
        },
        language() {
            return this.$i18n.locale;
        },
        isMobile() {
            return this.$store.state.isMobile ? 'mobile' : '';
        },
        isLauncher() {
            return navigator.userAgent.indexOf('NexonLauncher') > 0;
        },
        channel() {
            if (this.isLauncher) return 'launcher';
            if (this.isMobile) return 'mobile';
            return 'web';
        },
        currentVersion() {
            return process.env.VUE_APP_VERSION;
        },
        environment() {
            return process.env.VUE_APP_ENV;
        },
        webApi() {
            return config[process.env.NODE_ENV][environment.region].API;
        },
        cdnHost() {
            return process.env.VUE_APP_CDN_HOST;
        },
    },
    mounted() {
        this.storeChannel();
        window.version = `Current Version => ${process.env.VUE_APP_VERSION}`;
    },
    methods: {
        whenLoading() {
            const mainSpinner = document.getElementById('main-spinner');
            if (!mainSpinner.classList.contains('hide')) {
                mainSpinner.className += ' hide';
            }
            this.$eventBus.$emit('show-loading-overlay');
        },
        afterLoading() {
            this.$eventBus.$emit('hide-loading-overlay');
        },
        storeChannel() {
            const shop = document.getElementById('body');
            this.$store.commit('setAppType', this.channel);
            shop.classList.add(this.channel);
        },
    },
};
</script>

<style lang="less">
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
@import './less/global';
@import './less/responsive';
@import './less/tooltip';
</style>
